import { render } from "./section-devices.vue?vue&type=template&id=3a38d24c"
import script from "./section-devices.vue?vue&type=script&lang=js"
export * from "./section-devices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__